import { Category } from '../../documents';
import { SponsorReportsStorage } from '../sponsor-reports-storage';
import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoriesStorage, Report } from '../../documents';
import { Observable } from 'rxjs';
import { map, switchMap, filter, distinctUntilChanged } from 'rxjs/operators';
import { SponsorRouteData } from '../sponsor-route-data';
import { routeParams } from '../../shared/route-helpers';

@Component({
    selector: 'app-category-child',
    template: require('./documents-by-child.component.html'),
    styles: [require('./shared/documents.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentsByChildComponent implements OnInit {
    public selectedCategory$: Observable<Category>;
    public reports$: Observable<Report[]>;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly routeData: SponsorRouteData,
        private readonly categoriesStorage: CategoriesStorage,
        private readonly reportsStorage: SponsorReportsStorage,
    ) { }

    public ngOnInit() {
        this.selectedCategory$ = this.route.params.pipe(
            map(x => x[routeParams.childCategoryId]),
            switchMap(x => this.categoriesStorage.findCategoryById(x))
        );

        const selectedStudy$ = this.routeData.selectedStudy.pipe(
            filter(x => !!x),
            distinctUntilChanged()
        );

        this.reports$ = this.reportsStorage.loadStudyReports(selectedStudy$, this.selectedCategory$);
    }
}